import { useForm, DefaultValues } from 'react-hook-form';
import type { SysAdminUserCreate, SysAdminUserUpdate } from '../types/sysadmin-user.types';
import { useCallback } from 'react';

export interface UseSysAdminUserFormProps {
  defaultValues?: DefaultValues<SysAdminUserCreate | SysAdminUserUpdate>;
  onSubmit: (data: SysAdminUserCreate | SysAdminUserUpdate) => void;
}

export const useSysAdminUserForm = ({ defaultValues, onSubmit }: UseSysAdminUserFormProps) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    setValue,
  } = useForm<SysAdminUserCreate | SysAdminUserUpdate>({
    defaultValues: defaultValues || {
      name: undefined,
      email: undefined,
    },
  });

  const resetForm = useCallback(() => {
    reset();
  }, [reset]);

  const submitHandler = useCallback(
    (data: SysAdminUserCreate | SysAdminUserUpdate) => {
      onSubmit(data);
    },
    [onSubmit]
  );

  const formSubmitHandler = useCallback(() => {
    return handleSubmit(submitHandler);
  }, [handleSubmit, submitHandler]);

  return {
    control,
    errors,
    resetForm,
    formSubmitHandler,
    reset,
    setError,
    setValue,
  };
};
